import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import { Box, Button, Backdrop, CircularProgress } from '@mui/material';
import { Tabla, TextFieldAutoComplete } from 'ui-component';
import MainCard from 'ui-component/cards/MainCard';
import AgregarColaborador from './Components/AgregarColaborador';
import CursoSesion from './Components/CursoSesion';
import Confirm from './Components/Confirm';

import TabContext from '@mui/lab/TabContext';
import GroupsIcon from '@mui/icons-material/Groups';

import Services from './Components/services';
import headers from './Components/headers';
import { useLogin } from 'Context/ContextLogin';

const TrainerAdministrativo = ({ permisos, ...props }) => {
    const services = Services();
    const { usuario } = useLogin();
    const [confirm, setConfirm] = useState({ open: false, title: '', text: '', cancel: () => {}, accept: () => {} });
    const [cargando, setCargando] = useState(false);

    const [agregarColaborador, setAgregarColaborador] = useState({
        open: false,
        title: '',
        data: { row: [], personal: [] },
        cancel: () => {}
    });
    const [cursoSesion, setCursoSesion] = useState({
        open: false,
        title: '',
        data: { row: [], personal: [] },
        cancel: () => {}
    });
    const [value, setValue] = useState('1');
    const [personal, setPersonal] = useState({ personal: [], allData: [] });
    const [personalOOAM, setPersonalOOAM] = useState({ personal: [], allData: [] });

    const [administrativo, setAdministrativo] = useState([]);
    const [operativo, setOperativo] = useState([]);
    const [grupos, setGrupos] = useState([]);
    const [listaDetalles, setListaDetalles] = useState([]);
    const [listaSesiones, setListaSesiones] = useState([]);
    const [cursoActual, setCursoActual] = useState(null);

    // Services
    const getInfoInicial = () => {
        services.getInfoNuevo(
            (res) => {
                setAdministrativo(res.personal);
                setGrupos(res.grupos);
            },
            { tipo_puesto: 'Administrativa' }
        );
    };

    const cargarFunciones = () => {
        getInfoInicial();
    };

    const closeCursoSesion = () => {
        setCursoSesion({ open: false, title: '', data: { row: [], personal: [] }, cancel: () => {} });
    };

    const cursoSesAvance = (row) => {
        setCursoSesion({
            open: true,
            title: 'Curso y Sesiones',
            data: { personal: personalOOAM.personal, tipo: value, withLeader: 0, persona: row },
            cancel: closeCursoSesion
        });
    };
    const bloquearColaborador = (row) => {
        const dataSend = { idContrato: row.idcontrato, idPersona: row.idpersona, isBloqueado: !(row.isBloqueado == 1), tipo: value };
        services.bloquearColaborador((res) => {
            let newPersonal = [];
            if (value == '1') newPersonal = personal.personal;
            else newPersonal = personalOOAM.personal;
            const index = newPersonal.findIndex((per) => per.idcontrato == res.personal.idcontrato);
            if (index != -1) newPersonal[index] = res.personal;
            setPersonal({ ...personal, personal: newPersonal });
        }, dataSend);
    };
    const asigGrup = () => {
        setAgregarColaborador({
            open: true,
            title: 'Agregar colaborador',
            data: { personal: administrativo, withLeader: 0 },
            cancel: closeAgregarColaborador
        });
    };
    const closeAgregarColaborador = () => {
        setAgregarColaborador({ open: false, title: '', data: { row: [], personal: [] }, cancel: () => {} });
    };
    const accionesFilaOOAM = [
        { label: 'Bloquear', onClick: (row) => bloquearColaborador(row), enabled: (row) => row.isBloqueado == 0 },
        { label: 'Desbloquear', onClick: (row) => bloquearColaborador(row), enabled: (row) => row.isBloqueado == 1 },
        { label: 'Activar Sesiones', onClick: cursoSesAvance, enabled: (row) => !(row.isTrainer == 1) }
    ];
    const acciones = [
        {
            label: 'Asignar Curso',
            icon: <GroupsIcon />,
            click: (data) => (even) => {
                asigGrup(1, data);
            },
            dataSelected: false
        }
    ];

    const cambioMaterial = (material) => {
        if (material) {
            setCursoActual(material);
            services.getDatosCurso(
                (res) => {
                    console.log('res', res);
                    setListaDetalles(res.detalles);
                    setListaSesiones(res.sesiones);
                },
                { idCurso: material.idCurso }
            );
        }
    };

    const ejecutaInsert = (arr) => {
        services.insertaImportacion(
            (res) => {
                console.log('res', res);
            },
            { info: arr }
        );
    };

    const cambioArchivo = (file) => {
        if (file && file != null) {
            const reader = new FileReader();
            reader.onload = (event) => {
                setCargando(true);
                const data = new Uint8Array(event.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(sheet);
                // console.log('data', jsonData);

                let arregloEnviar = [];
                jsonData.forEach((element) => {
                    const idColab = element.idColaborador;

                    if (idColab && idColab != null) {
                        let str = [];
                        str.push(
                            `insert into tcolaborador_grupo (estatus, isLider, fechaCreacion, idUsuario, idGrupo, idColaborador) values (1, 0, now(), 1, ${cursoActual.idGrupo}, ${idColab});`
                        );

                        let result = Object.keys(element).map((key) => [key, element[key]]);

                        result.forEach((el) => {
                            if (el[0].includes('idCurso') && el[1] == 'SI') {
                                // let separado = el[0].split('_');
                                let conCurso = `insert into tcalificacionCurso (estatus, fechaCreacion, idUsuario, idColaborador, idCurso, calificacion, isAprobado) values (1, now(), 1, ${idColab}, ${cursoActual.idCurso}, 100, 1);`;
                                str.push(conCurso);
                            }

                            if (el[0].includes('idSesion') && el[1] == 'SI') {
                                let separSes = el[0].split('_');
                                let conSesion = `insert into tcalificacionSesion (estatus, fechaCreacion, idUsuario, idColaborador, idSesion, calificacion, isAprobado) values (1, now(), 1, ${idColab}, ${separSes[1]}, 100, 1);`;
                                str.push(conSesion);
                                let tem = listaSesiones.find((x) => x.idSesion == separSes[1]);
                                let conTem = `insert into tcalificacionTemario (estatus, fechaCreacion, idUsuario, idColaborador, idTemario, calificacion, isAprobado) values (1, now(), 1, ${idColab}, ${tem.idTemario}, 100, 1);`;
                                str.push(conTem);
                            }

                            if (el[0].includes('idActividad') && el[1] == 'SI') {
                                let separAct = el[0].split('_');
                                let conAct = `insert into tcalificacionActividad (estatus, fechaCreacion, idUsuario, idColaborador, idActividad, calificacion, isAprobado) values (1, now(), 1, ${idColab}, ${separAct[1]}, 100, 1);`;
                                str.push(conAct);
                            }

                            if (el[0].includes('idDetalle_calificacion') && Number(el[1]) != 0) {
                                let separDet = el[0].split('_');
                                let datosDet = listaDetalles.find((x) => x.idDetalleActividad == separDet[2]);
                                let conDet = `insert into tcalificacionDetalle (estatus, fechaCreacion, idUsuario, idColaborador, idDetalleActividad, idActividad, idTemario, idSesion, idCurso, idTipoActividad, calificacion, isAprobado) values (1, now(), 1, ${idColab}, ${separDet[2]}, ${datosDet.idActividad}, ${datosDet.idTemario}, ${datosDet.idSesion}, ${cursoActual.idCurso}, ${datosDet.idTipoActividad}, ${el[1]}, 1);`;
                                str.push(conDet);
                            }
                        });

                        arregloEnviar.push({ colaborador: idColab, arreglo: str });
                    }
                });
                // console.log('str', arregloEnviar);
                ejecutaInsert(arregloEnviar);
                setCargando(false);
            };
            reader.readAsArrayBuffer(file);
        } else {
            setMensaje({ open: true, status: -1, value: 'falta archivo' });
        }
    };

    useEffect(() => {
        cargarFunciones();
    }, []);
    return (
        <>
            <MainCard title="Lista de colaboradores">
                <TabContext value={value}>
                    <Tabla
                        rows={administrativo}
                        columns={headers(() => {}).administrativo}
                        accionesTabla={acciones}
                        accionesFila={accionesFilaOOAM}
                        columnKey="idpersona"
                    />
                    <Confirm
                        open={confirm.open}
                        title={confirm.title}
                        text={confirm.text}
                        cancel={confirm.cancel}
                        accept={confirm.accept}
                    />
                    <AgregarColaborador
                        tipoPersonal={'2'}
                        open={agregarColaborador.open}
                        title={agregarColaborador.title}
                        data={agregarColaborador.data}
                        cancel={agregarColaborador.cancel}
                        updatesetPersonal={getInfoInicial}
                        infoUsuario={props.usuario}
                    />
                    <CursoSesion
                        open={cursoSesion.open}
                        title={cursoSesion.title}
                        data={cursoSesion.data}
                        cancel={cursoSesion.cancel}
                        updatesetPersonal={getInfoInicial}
                        setTabla={setPersonalOOAM}
                        tabla={personalOOAM?.personal}
                        infoUsuario={props.usuario}
                    />
                </TabContext>

                {/* <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
                    <TextFieldAutoComplete
                        label="Curso"
                        // control={control}
                        name="material"
                        // {...register('material')}
                        // rules={{ required: { value: true, message: 'Campo requerido' } }}
                        options={grupos || []}
                        optionSelected={{ label: 'nombre', id: 'idGrupo' }}
                        // error={errors.material?.message}
                        onChange={cambioMaterial}
                    />
                    <input
                        accept=".xlsx, .xls"
                        style={{ display: 'none' }}
                        onChange={(e) => cambioArchivo(e.target.files[0] ? e.target.files[0] : null)}
                        id="contained-button-file"
                        type="file"
                    />
                    <label htmlFor="contained-button-file">
                        <Button component="span" variant="contained" color="primary" size="medium" fullWidth>
                            Subir archivo
                        </Button>
                    </label>
                </div> */}
            </MainCard>
            {/**<Backdrop open={cargando}>
                <CircularProgress color="inherit" />
            </Backdrop>**/}
        </>
    );
};

export default TrainerAdministrativo;
